export const prepareDataSource = (event, entity) => {
  const {
    id,
    type,
    created,
    [`${entity}_id`]: entityId,
    ...eventExtraData
  } = event;
  const eventExtraDataKeys = Object.keys(eventExtraData);
  let extraData = null;

  const commonData = [
    {label: 'ID', value: id},
    ...(entityId ? [{label: `${entity} ID`, value: entityId}] : []),
    {label: 'Type', value: type},
    {label: 'Created At', value: created},
  ];

  if (eventExtraDataKeys.length > 0) {
    extraData = eventExtraDataKeys.map((key) => {
      const rawValue = eventExtraData[key];
      // Convert objects and arrays to JSON string for display (e.g., details field in TeamsAlertSent events)
      // Note: Arrays are also typeof 'object' in JavaScript and will be stringified
      const value = typeof rawValue === 'object' && rawValue !== null
        ? JSON.stringify(rawValue, null, 2)
        : rawValue;

      return {
        label: key
          .replace(/_/gi, ' ')
          .replace('id', 'ID')
          .replace('member', 'record'),
        value,
      };
    });
  }

  return {commonData, extraData};
};
